import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../mock';

const WhatsAppButton = () => {
  const handleClick = () => {
    const whatsappUrl = `https://wa.me/91${companyInfo.phone}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="animate-pulse" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-1 rounded-md text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        Chat with us
      </span>
    </button>
  );
};

export default WhatsAppButton;
